<template>
    <div style="height:100%">
    <div  id="csContainer"></div>
     <img  id="sillygif" src="../../assets/marks/emergency.gif" style="">
    </div>
</template>
<script>
import util from "../../components/util"

export default {
    data () {
        return {
            viewer:null
        }
    },
    mounted(){
    this.init()
    },
    methods:{
         init () {
            this.viewer=util.getViewer('csContainer',{
                 shouldAnimate: true,
                 infoBox:true,
                 selectionIndicator: true,
            });
            // this.viewer.scene.camera.setView({
            //         destination: new Cesium.Cartesian3.fromDegrees(-111.94500779274114, 36.27638678884143,200),
            //         orientation: new Cesium.HeadingPitchRoll(4.239925103568368, -0.4911293834802475, 6.279849292088564),
            //     });
          
            var htmlOverlay = document.getElementById('sillygif');
            // img.onload=() =>{
            //     var rub = new SuperGif({
            //           gif: img
            //     });
            //      rub.load(() => {
            //         var entity = this.viewer.entities.add({
            //         position: Cesium.Cartesian3.fromDegrees(114, 30),
            //         billboard: {
            //             image: new Cesium.CallbackProperty(() => {
            //             return rub.get_canvas().toDataURL("image/png");
            //             }, false),
            //             verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            //             heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
            //             scaleByDistance: new Cesium.NearFarScalar(500, 1.0, 2000, 0.1)
            //          }
            //         });
            //         this.viewer.trackedEntity = entity;
                   
            //     });
            // };
            var scratch = new Cesium.Cartesian2();
            this.viewer.scene.preRender.addEventListener(()=> {
            var position = new Cesium.Cartesian3.fromDegrees(116.292498, 40.042018);
            //将笛卡尔坐标中的位置转换为画布坐标。将HTML元素与场景中的对象放置在同一屏幕位置。
            var canvasPosition = this.viewer.scene.cartesianToCanvasCoordinates(position, scratch);
                    if (Cesium.defined(canvasPosition)) {
                        htmlOverlay.style.top = canvasPosition.y + 'px';
                        htmlOverlay.style.left = canvasPosition.x + 'px';
                    }
                });
            this.viewer.camera.setView({
                  destination : Cesium.Cartesian3.fromDegrees(116.292498, 40.042018, 5100),

               });
          }
       } 
}
</script>
<style scoped>
#csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
}
#sillygif {
    position: absolute; 
    width: 70px;
    height:80px;
    z-index: 2
}
</style>